import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';

const AuthLanguageSwitcher = () => {
	const { locale, changeLocale } = useLanguage();
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	const languages = [
		{ code: 'en', name: 'English', countryCode: 'us' },
		{ code: 'es', name: 'Español', countryCode: 'es' },
		{ code: 'it', name: 'Italiano', countryCode: 'it' },
		{ code: 'nl', name: 'Nederlands', countryCode: 'nl' },
		{ code: 'ae', name: 'العربية', countryCode: 'ae' }
	];

	const selectedLanguage = languages.find(lang => lang.code === locale) || languages[0];

	const handleSelect = (langCode) => {
		changeLocale(langCode);
		setIsOpen(false);
	};

	const handleClickOutside = useCallback((event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	}, []);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [handleClickOutside]);

	return (
		<div className="position-relative" ref={dropdownRef}>
			<button
				className="btn d-flex align-items-center"
				onClick={() => setIsOpen(!isOpen)}
				style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
				aria-haspopup="true"
				aria-expanded={isOpen}
			>
        <span
					className={`fi fi-${selectedLanguage.countryCode}`}
					style={{ marginRight: '8px', fontSize: '1.2rem' }}
					aria-label={`${selectedLanguage.name} flag`}
				></span>
				<span style={{ color: '#333' }}>{selectedLanguage.name}</span>
				<FaChevronDown size={12} style={{ marginLeft: '8px', color: '#666' }} />
			</button>

			{isOpen && (
				<div
					className="bg-white border rounded p-2"
					style={{
						position: 'absolute',
						top: '100%',
						right: locale === 'ae' ? 'auto' : '0',
						left: locale === 'ae' ? '0' : 'auto',
						marginTop: '10px'
					}}
				>
					{languages.map((lang) => (
						<a
							key={lang.code}
							className={`dropdown-item d-flex align-items-center ${locale === lang.code ? 'active' : ''}`}
							href="#"
							onClick={(e) => {
								e.preventDefault();
								handleSelect(lang.code);
							}}
							style={{ padding: '8px 16px' }}
						>
              <span
								className={`fi fi-${lang.countryCode}`}
								style={{ marginRight: '10px', fontSize: '1.2rem' }}
							></span>
							{lang.name}
						</a>
					))}
				</div>
			)}
		</div>
	);
};

export default AuthLanguageSwitcher;
